import { API_CENTRE } from "./config";
import _o2sService from "./_o2sServices";
import { IFilter } from "../models/filters/filter";

import { ITypeLocationFilter } from "../models/filters/typeLocationFilter";
import { ITypeLocationForm } from "../models/forms/typeLocationForm";
import { ITypeLocationPDTO } from "../models/dtos/typeLocationPDTO";

// Service for TypeLocation operations
export default class TypeLocationService extends _o2sService {

    protected static override mainUrl:string = API_CENTRE + "/api/v1/TypeLocation";

    protected static override  getUrlFilter<F extends ITypeLocationFilter>(filter?: F):string {
        let url = super.getUrlFilter(filter as IFilter);
        if ( filter != null)
        {
            if(filter.isIncremental != undefined)
                url += `&IsIncremental=${filter.isIncremental}`;
            if(filter.isBoarAllowed != undefined)
                url += `&IsBoarAllowed=${filter.isBoarAllowed}`;
        }

        return url;
    }

    public static override toDTO(obj:ITypeLocationForm):ITypeLocationPDTO {
        const dto = super.toDTO(obj) as ITypeLocationPDTO;
        return dto;
    }
}
